/**
 * Page status constants used to track the completion state of onboarding pages.
 * 
 * @readonly
 * @enum {string}
 */
const PageStatus = Object.freeze({
    /** Page has been initiated but not yet completed */
    Started: "Started",
    /** Page has been successfully completed */
    Completed: "Completed",
    /** Page has not been started yet */
    NotStarted: "NotStarted"
});

export default PageStatus;
export { PageStatus };